import MapperBase from '../MapperBase.js';
import RunnerSafeType from '../../enums/RunnerSafeType.js';

class MlbRunnerSafeTypeMapper extends MapperBase {
    constructor(silent) {
        super(silent, RunnerSafeType.Safe.key);
    }

    /**
     * 
     * @param {*} item from liveData.plays.allPlays[*].runners[*].details
     * @returns {String} - value from RunnerSafeType enum
     */
    mapSingle(item) {
        // Unfortunately there is no api doc containing all possible values for this...
        switch (item.eventType) {
            case 'home_run': // TODO - mauybe we also need home run type ?
                return RunnerSafeType.OnLastPlay.key;
            case 'wild_pitch':
                return RunnerSafeType.OnWildPitch.key;
            case 'passed_ball': // TODO - never saw it, but should be here as well
                return RunnerSafeType.OnPassedBall.key;
            case 'field_error':
                return RunnerSafeType.FieldingError.key;
            case 'error': // TODO - saw it in a few games, usually fielder received throwing error credit
                return RunnerSafeType.ThrowingError.key;

            default:
                // sometimes movementReason stays null and we need to figure out in other way...
                switch (item.movementReason) {
                    case 'r_adv_play':
                        return RunnerSafeType.OnLastPlay.key;
                    case 'r_adv_force':
                        return RunnerSafeType.ForcePlay.key;
                    case 'r_stolen_base_3b':
                    case 'r_stolen_base_2b':
                    case 'r_stolen_base_home':
                        return RunnerSafeType.StolenBase.key;
                    case 'r_adv_throw':
                        return RunnerSafeType.OnThrow.key;
                    case 'r_pickoff_error_1b': // TODO - not sure about it, found one example and runner received throwing error
                    case 'r_pickoff_error_2b':
                    case 'r_pickoff_error_3b':
                        return RunnerSafeType.ThrowingError.key;
                }
                break;
        }

        throw new Error(`Unable to map runner movement of type ${item.eventType}, reason ${item.movementReason}`);
    }
}

export default MlbRunnerSafeTypeMapper;